import { useEffect } from 'react';
import { trackCheckoutPaymentModalView } from './pulseCheckoutPaymentViews';

/** Pulse view when checkout credit / gift card modals open (Add vs Edit button). */
export function useCheckoutPaymentModalPulseView(params: {
  showCreditModal: boolean;
  showGiftModal: boolean;
  isEditCredit: boolean;
  isEditGift: boolean;
  pagePath?: string;
}): void {
  const {
    showCreditModal,
    showGiftModal,
    isEditCredit,
    isEditGift,
    pagePath,
  } = params;

  useEffect(() => {
    if (!showCreditModal) return;
    trackCheckoutPaymentModalView({
      kind: 'credit',
      isEdit: isEditCredit,
      pagePath,
    });
    // Fire once per modal open
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showCreditModal]);

  useEffect(() => {
    if (!showGiftModal) return;
    trackCheckoutPaymentModalView({
      kind: 'gift',
      isEdit: isEditGift,
      pagePath,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showGiftModal]);
}
